var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('skeleton-loader',{attrs:{"type":"detail"}}):_c('div',[_c('routine-detail',{attrs:{"routine":_vm.currentRoutine},on:{"selectRoutine":_vm.onSelectRoutine,"updated":_vm.onUpdated}}),_c('assign-routine-dialog',{ref:"assign",attrs:{"routine-id":_vm.routineId,"coach-id":_vm.coachId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }